import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_PRODUCTS = "GET_PRODUCTS";

export function getProductsAction(products) {
  return { type: GET_PRODUCTS, products: products };
}

export const getProductsPaginated = function (page, limit, searchQuery) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getProductsPaginated, {
        params: { page, limit, searchQuery },
      })
      .then(function (response) {
        dispatch(getProductsAction(response.data));
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const getProductsCount = function (successCallback) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getProductsCount)
      .then(function (response) {
        return successCallback(response.data);
      })
      .catch(function (err) {
        throw err;
      });
  };
};

export const isProductKeywordAlreadyExists = function (
  keyword,
  existsCallback,
  noExistsCallback,
) {
  return function () {
    return axios
      .get(APIUrl.isProductKeywordAlreadyExists + encodeURIComponent(keyword))
      .then(function (response) {
        if (response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const addProduct = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.addProduct, data)
      .then(function (response) {
        if (successCallback) return successCallback(response.data);
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const updateProduct = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.updateProduct, data)
      .then(function (response) {
        if (response) if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const deleteProduct = function (data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteProduct, data)
      .then(function (response) {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

// IMG

export const addProductImage = function (productId, data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.addProductImage + productId, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function () {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

// DOCUMENTS

export const addProductDocuments = function (productId, data, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.addProductDocument + productId, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(function () {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const deleteProductDocument = function (documentId, successCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.deleteProductDocument, { documentId: documentId })
      .then(function (response) {
        if (successCallback) return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};
